module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [(_vm.divided) ? _c('div', {
    staticClass: "dropdown__divider"
  }) : _vm._e(), _vm._v(" "), _c('a', {
    class: _vm.classes,
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$_onDropdownItemClick($event)
      }
    }
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76057a26"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dropdown/dropdown-item.vue
// module id = 386
// module chunks = 0